import CogIcon from '@heroicons/react/outline/esm/CogIcon.js'
import { Link } from 'react-router-dom'

import { T } from '@tribeplatform/react-components/i18n'
import { SystemSpaceSlug, useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

export const NotificationSettingsLink = props => {
  const { generatePath } = useSpaceUtil()

  return (
    <Link
      to={`${generatePath(SystemSpaceSlug.PROFILE_SETTINGS)}/notifications`}
      {...props}
    >
      <Tooltip>
        <Tooltip.Trigger>
          <CogIcon
            className="h-6 w-6 text-content-subdued hover:text-content-hovered"
            aria-hidden="true"
          />
        </Tooltip.Trigger>
        <Tooltip.Panel className="z-20">
          <T
            defaultMessage="Notification settings"
            id="Generics.NotificationSetting"
          />
        </Tooltip.Panel>
      </Tooltip>
    </Link>
  )
}
